<div class="card">
    <div class="flex flex-col gap-6 items-center w-full" *ngIf="ready">
        <div class="w-full">
            <button class="button-elevation p-2 rounded-full" (click)="goBackToMissioniEsplorative()">Tutte le missioni esplorative</button>
        </div>

        <div class="w-full shadow-medium p-4 rounded-3xl">
            <p class="text-2xl">Missione esplorativa</p>
            <app-dynamic-form
                #myForm
                [options]="form2Opts"
                [fields]="regConfig2"
                (resetData)="initializeForm()"
                (onFieldChangeEmitter)="handleFormFieldChange($event)"
                (onSwitchChange)="handleIndoorToggle($event)"
                (submit)="submit($event)">
            </app-dynamic-form>
        </div>

        @if (object?.unlockType === 'qr') {
            <div class="w-full shadow-medium p-4 rounded-3xl">
                <p class="text-2xl mb-2">QR Code</p>
                <p class="p-2">Lo sblocco avverrà dopo la scansione del QR Code</p>
                @if (object?.qrCodes?.length) {
                    <div class="qr-display w-fit rounded-2xl p-2" style="background-color: #1e1e1e;">
                        @for (item of object?.qrCodes; track $index; let i = $index) {
                            <div class="qr-content flex flex-col items-center justify-center" style="background-color: #1e1e1e;">
                                <qrcode #qrComp [qrdata]="item.code" [width]="256" [errorCorrectionLevel]="'M'"
                                        [colorDark]="'#F7F737'" [colorLight]="'#1e1e1e'" [elementType]="'canvas'">
                                </qrcode>
                                <div style="background-color: #1e1e1e;" class="code-text text-center"><b>{{ item.code }}</b></div>
                                <button type="button" [disabled]="loadingQrCode" class="btn button-elevation p-2 rounded-full my-2" (click)="downloadQR(i, item.code)">
                                    <div>Scarica PNG</div>
                                </button>
                            </div>
                        }
                    </div>
                } @else {
                    <p class="p-2 text-red-500 font-bold">Il QR Code verrà generato in automatico dopo il salvataggio delle modifiche</p>
                }
            </div>
        }

        @if (object) {
            <div class="w-full shadow-medium p-4 rounded-3xl">
                <p class="text-2xl">Step</p>
                <app-gestione-step [idMission]="object.id"></app-gestione-step>
            </div>
        }

        @if (isIndoor) {
            <div class="w-full shadow-medium p-4 rounded-3xl">
                <p class="text-2xl">Mappa indoor</p>
                <app-mappa-indoor [missionId]="object?.id ?? null"></app-mappa-indoor>
            </div>
        }
    </div>
</div>
